import { Model, View } from "@lernetz/ts-lib";
import { Subscription } from "@lernetz/ts-lib/src/Signal";
import { Image } from "../../../components/article-elements/image/Image";
import { gateway } from "../../../services/gateway";
import { trackEvent } from "../../../services/tracker";
import { getState } from "../../../state";
import { ToolModule } from "../../../tool/tool.module";
import template from "./tool-details.view.html";

export class ToolDetailsView extends View {
    constructor() {
        super({ template, registry: ToolModule.views });
    }
}

export class ToolDetailsController extends Model {
    tool: any;
    infos: { metainfos: any; hint: { title: any; text: any }; downloads: any };
    listener: void;
    isSticky: any;
    scrollTopChangingPoint: number;
    scrollSubscription: Subscription;
    load(toolId) {
        gateway.toolGateway.get(toolId).then((tool) => {
            this.tool = tool;
            this.infos = {
                metainfos: tool.metainfos,
                hint: {
                    title: tool.hintTitle,
                    text: tool.hintText,
                },
                downloads: tool.downloads,
            };
            trackEvent("tool-details", { tool: tool.title });
        });
    }
    init() {
        const globalState = getState();
        this.scrollSubscription = globalState.scroll.subscribe((event) => {
            if (window.matchMedia("(min-width: 1024px)").matches) {
                const scrollContainer =
                    document.getElementById("scroll-container");
                const stickyBox = document.getElementById("sticky-box");
                const extraInfoContainer = document.getElementById("extraInfo-container");
                const { top: scrollContainerTop } =
                    scrollContainer.getBoundingClientRect();
                const { top: stickyBoxTop , bottom: stickyBoxBottom} = stickyBox.getBoundingClientRect();
                const { top: extraInfoTop } = extraInfoContainer.getBoundingClientRect();
                if (!this.isSticky && stickyBoxTop < scrollContainerTop) {
                    this.isSticky = true;
                    const stickyBoxDistanceToTop =
                        scrollContainerTop - stickyBoxTop;
                    this.scrollTopChangingPoint =
                        scrollContainer.scrollTop - stickyBoxDistanceToTop;
                    stickyBox.classList.add("fixed");
                    stickyBox.classList.add("z-10");
                    stickyBox.classList.add("w-80");
                    stickyBox.style.top = `${scrollContainerTop}px`;
                } else if (
                    this.isSticky &&
                    scrollContainer.scrollTop < this.scrollTopChangingPoint
                ) {
                    this.isSticky = false;
                    stickyBox.classList.remove("fixed");
                    stickyBox.classList.remove("z-10");
                    stickyBox.classList.remove("w-80");
                    stickyBox.style.top = null;
                }
                const offset = 100;
                if (
                    this.isSticky &&
                    extraInfoTop < stickyBoxBottom + offset
                   ) {
                    stickyBox.classList.add("opacity-0");
                    stickyBox.classList.remove("opacity-100");
                    // stickyBox.classList.add("invisible");
                } else if (
                    this.isSticky &&
                    extraInfoTop > stickyBoxBottom - offset
                ) {
                    stickyBox.classList.add("opacity-100");
                    stickyBox.classList.remove("opacity-0");
                    // stickyBox.classList.remove("invisible");
                }
            }
        });
    }
    deinit() {
        this.scrollSubscription.unsubscribe();
    }
}
